import { PAPEIS, type Papel } from "@/api/contrato";

/*
 * `leitura` ⊂ `operador` ⊂ `admin`, por força crescente. Cada rota declara o
 * papel mínimo em `x-papel-minimo` no contrato.
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ ESCONDER NÃO É AUTORIZAR.                                                │
 * │                                                                          │
 * │ Isto aqui decide o que a TELA mostra, e nada mais. A API recusa de       │
 * │ qualquer forma, e a auditoria registra a tentativa. Nenhuma decisão de   │
 * │ segurança pode depender deste arquivo — ele roda na máquina de quem      │
 * │ está do outro lado.                                                      │
 * └──────────────────────────────────────────────────────────────────────────┘
 */
const FORCA: Record<Papel, number> = { leitura: 1, operador: 2, admin: 3 };

function forcaDe(papel: string): number {
  /*
   * Papel desconhecido vale ZERO, e não "o máximo" nem "o mínimo conhecido".
   *
   * Se a API um dia devolver um papel que esta versão do painel não conhece, a
   * resposta certa é não conceder nada por causa dele — a tela some, o operador
   * reclama, e alguém atualiza o painel. O caminho oposto — assumir que um nome
   * novo é pelo menos `leitura` — concede acesso com base em algo que este
   * código não entende.
   */
  return papel in FORCA ? FORCA[papel as Papel] : 0;
}

/** A maior força entre os papéis do operador. Zero quando não há sessão. */
export function forcaMaxima(papeis: readonly string[]): number {
  return papeis.reduce((maior, papel) => Math.max(maior, forcaDe(papel)), 0);
}

/** O operador alcança o papel mínimo pedido? */
export function alcanca(papeis: readonly string[], minimo: Papel): boolean {
  return forcaMaxima(papeis) >= FORCA[minimo];
}

/** O papel mais forte, para exibir no menu do operador. */
export function papelMaximo(papeis: readonly string[]): Papel | null {
  const forca = forcaMaxima(papeis);
  return PAPEIS.find((papel) => FORCA[papel] === forca) ?? null;
}
